<template>
    <div class="company-select-component" ref="root">
        <input
            type="text"
            v-model="keyword"
            @click="openWindow"
            :class="inputClass"
            :placeholder="inputPlaceholder"
        />
        <input
            type="hidden"
            :value="selected.value"
            :id="inputId"
            :name="inputName"
        />

        <div v-show="isActive">
            <p class="msg" v-if="message">{{ message }}</p>
            <ul v-else class="list">
                <li v-for="(companies, place) in list" :key="place">
                    <p>{{ place }}</p>
                    <ul class="innerList">
                        <li
                            v-for="company in companies"
                            :key="company.corporateNumber"
                            @click="select(company)"
                        >
                            <p>
                                {{ company.name }} ({{
                                    company.corporateNumber
                                }})
                                <br />
                                <small>{{ company.fullAddress }}</small>
                            </p>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onBeforeUnmount, watch } from "vue";
import axios from "axios";
import { debounce } from "lodash";

export default {
    props: [
        "inputId",
        "inputName",
        "inputClass",
        "inputInit",
        "inputPlaceholder",
    ],

    setup(_props) {
        const keyword = ref("");
        const message = ref("");
        const list = ref({});
        const selected = reactive({
            value: null,
            name: null,
        });
        const isActive = ref(false);

        axios.defaults.headers.common["X-CSRF-Token"] = document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content");

        onMounted(() => {
            // フォーカスアウトで閉じる
            window.addEventListener("click", _onBlurHandler);
        });

        onBeforeUnmount(() => {
            window.removeEventListener("click", _onBlurHandler);
        });

        watch(keyword, (_newKeyword) => {
            search();
        });

        const search = debounce(() => {
            message.value = "検索しています...";
            isActive.value = true;

            if (keyword.value === selected.name) {
                return;
            }
            selected.value = null;
            selected.name = null;
            if (keyword.value.length < 1) {
                notFound();
                return;
            }
            fetch(keyword.value);
        }, 1000);

        const fetch = (keyword) => {
            axios
                .post("/api/company_master/search", {
                    keyword: keyword,
                })
                .then((response) => {
                    list.value = response.data;
                    if (Object.keys(list.value).length < 1) {
                        notFound();
                    } else {
                        message.value = "";
                    }
                })
                .catch((error) => {
                    if (error.response.status == 500) {
                        dbTimeOut();
                    } else if (error.response.status == 401) {
                        errorMessage();
                    }
                });
        };

        const select = (company) => {
            selected.value = company.corporateNumber;
            selected.name = company.name;
            keyword.value = selected.name;
            isActive.value = false;
        };

        const openWindow = () => {
            if (Object.keys(list.value).length > 0) {
                isActive.value = true;
            }
        };

        const notFound = () => {
            message.value = "該当する企業は見つかりませんでした";
        };

        const errorMessage = () => {
            message.value = "法人格のみでは検索できません";
        };

        const dbTimeOut = () => {
            message.value = "企業検索に失敗しました。時間を置いて再試行してください";
        };

        const _onBlurHandler = (event) => {
            if (event.target.closest(".company-select-component")) {
                return;
            }
            isActive.value = false;
        };

        return {
            keyword,
            message,
            list,
            selected,
            isActive,
            openWindow,
            select,
        };
    },
};
</script>
